import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import TenantPortal from "@/pages/TenantPortal";
import Layout from "@/components/Layout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import Clients from "@/pages/admin/Clients";
import Leads from "@/pages/admin/Leads";
import GarantiaWizard from "@/pages/admin/GarantiaWizard";
import ActiveContracts from "@/pages/admin/ActiveContracts";
import CreditAnalysis from "@/pages/admin/CreditAnalysis";
import Financial from "@/pages/admin/Financial";
import SiteSettings from "@/pages/admin/SiteSettings";
import PublicAnalysis from "@/pages/admin/PublicAnalysis";
import Delinquency from "@/pages/admin/Delinquency";
import "@/App.css";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <FullscreenLoader />;
  if (!user) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
}

function PublicOnly({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <FullscreenLoader />;
  if (user) return <Navigate to="/dashboard" replace />;
  return children;
}

function FullscreenLoader() {
  return (
    <div className="min-h-screen flex items-center justify-center" data-testid="loading-screen">
      <div className="text-slate-500 text-sm tracking-wide">Carregando…</div>
    </div>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/portal/:token" element={<TenantPortal />} />
            <Route path="/login" element={<PublicOnly><Login /></PublicOnly>} />
            <Route path="/dashboard" element={<Protected><AdminDashboard /></Protected>} />
            <Route path="/leads" element={<Protected><Leads /></Protected>} />
            <Route path="/clients" element={<Protected><Clients /></Protected>} />
            <Route path="/garantia" element={<Protected><GarantiaWizard /></Protected>} />
            <Route path="/contracts" element={<Protected><ActiveContracts /></Protected>} />
            <Route path="/credit" element={<Protected><CreditAnalysis /></Protected>} />
            <Route path="/analysis" element={<Protected><PublicAnalysis /></Protected>} />
            <Route path="/inadimplencia" element={<Protected><Delinquency /></Protected>} />
            <Route path="/financial" element={<Protected><Financial /></Protected>} />
            <Route path="/settings" element={<Protected><SiteSettings /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster richColors position="top-right" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
